import {useQuery} from "react-query";
import {fetchItem} from "../queries/queries-helper.ts";
import ENDPOINTS from "../services/endpoints.ts";
import IndicatorValueDto from "@/models/interfaces/dtos/indicators/indicator-value-dto.ts";

const usePromoterProjectDetails = (projectId: string, indicators: string[]) => 
    useQuery<IndicatorValueDto[]>(
        ['project-indicators', projectId],
        async () => {
            const data = await fetchItem<IndicatorValueDto[]>(ENDPOINTS.PROJECT_INDICATORS(projectId, indicators));
            if (data == null)
                return [];
            return data.map((item) => ({
                ...item,
                value: item.value ? Math.round(item.value) : item.value,
            }));
        },
        {
            enabled: !!projectId,
        }
    )

export default usePromoterProjectDetails;